import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IOrderData } from '@/api/types'

export const defaultOrderData: IOrderData = {
  orderId: 0,
  appointmentDate: null,
  inspectorId: null,
  vendorId: null,
  clientId: null,
  clientName: '',
  clientOrderId: '',
  appraisalId: '',
  lenderName: '',
  loanNumber: '',
  orderType: null,
  productId: null,
  orderStatusId: 0,
  floorPlanStatusId: 0,
  orderStatus: '',
  contactFirstName: '',
  contactLastName: '',
  contactPhone: '',
  contactPhone2: '',
  contactEmail: '',
  pdcLicenseExpireDate: '',
  pdcLicenseIdentifier: '',
  pdcLicenseType: '',
  pdcLicenseState: '',
  personAtPropertyType: '',
  subjectAddress: '',
  subjectAddress2: '',
  subjectCity: '',
  subjectState: '',
  subjectPostalCode: '',
  subjectCountry: 'US',
  subjectCounty: '',
  terms: '',
  borrowerName: '',
  borrowerName2: '',
  createDate: null,
  lastModifiedDate: null,
  inspectionDate: null,
  latitude: 0,
  longitude: 0,
  floorPlan: null,
  inspector: null,
  vendor: null,
  inspectorComments: '',
  exterior: null,
  interior: null,
  photos: [],
  avmData: null,
  vendorFee: 0,
  orderFee: 0,
  product: null,
  client: null,
  orderTypeNavigation: null,
  deleted: false,
  sellerId: null,
  lpaKey: null
}

export interface IOrdersState {
  orderList: IOrderData[]
  orderSelected: (IOrderData | null)
  search: (string | null)
  filter: (string | null)
}

@Module({ dynamic: true, store, name: 'order' })
class Orders extends VuexModule implements IOrdersState {
  public orderList: IOrderData[] = []
  public orderSelected: IOrderData | null = null
  public search: string | null = null
  public filter: string | null = null

  @Mutation
  private DEL_ALL_ORDERS() {
    this.orderList = []
  }

  @Mutation
  private LOAD_ORDERS(orders: IOrderData[]) {
    this.orderList = orders
  }

  @Mutation
  private SET_SELECTED(order: IOrderData | null) {
    this.orderSelected = order
  }

  @Mutation
  private SET_FILTER(filter: string | null) {
    this.filter = filter
  }

  @Mutation
  private SET_SEARCH(search: string | null) {
    this.search = search
  }

  @Mutation
  private UPDATE_ORDER(order: IOrderData) {
    for (let v of this.orderList) {
      if (v.orderId === order.orderId) {
        v = Object.assign(v, order)
        break
      }
    }
  }

  @Action
  public createNewOrder(): IOrderData {
    return defaultOrderData
  }

  @Action
  public loadOrders(orders: IOrderData[]) {
    this.DEL_ALL_ORDERS()
    this.LOAD_ORDERS(orders)
  }

  @Action
  public setFilterValue(filter: string) {
    this.SET_FILTER(filter)
  }

  @Action
  public setSearchValue(search: string) {
    this.SET_SEARCH(search)
  }

  @Action
  public setSelectedOrder(order: IOrderData) {
    this.SET_SELECTED(order)
  }

  @Action
  public updateOrder(order: IOrderData) {
    if (this.orderSelected == null) return
    if (this.orderSelected.orderId !== order.orderId) return
    this.SET_SELECTED(order)
    this.UPDATE_ORDER(order)
  }
}

export const OrdersModule = getModule(Orders)
